export default class tyomaaAuthClass {
  constructor() {
    this.isLoaded = false;
    this.read = true; // read permission to tyomaa, this is the minimun for opening anything
    this.edit = false; // edit permission to tyomaa and keikka
    this.createKeikka = false; // allow creating new keikka
    this.listPersons = false; // allow listing of tyomaa and keikka persons
    this.addPerson = false; // allow add/remove tyomaa and keikka persons
    this.editPerson = false; // allow change of main contact of tyomaa and keikka
  }
  setAuthDataFromJson(jsonData) {
    try {
      this.read = true;
      this.edit = jsonData.editTyomaa || false;
      this.createKeikka = jsonData.createKeikka || false;
      this.listPersons = jsonData.listTyomaaPersons || false;
      this.addPerson = jsonData.addTyomaaPerson || false;
      this.editPerson = jsonData.editTyomaaMainPerson || false;
      this.isLoaded = true;
    } catch (err) {
      console.log(err);
    }
  }
  get tyomaaAuthHash() {
    return (
      (this.read ? 2 : 1) +
      (this.edit ? 4 : 1) +
      (this.createKeikka ? 8 : 1) +
      (this.listPersons ? 16 : 1) +
      (this.addPerson ? 32 : 1) +
      (this.editPerson ? 64 : 1)
    );
  }
}
